import { ProgressBar } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { onsaProgressSelector } from '../../recoil/selectors/onsaProgressSelector';

const OnsaProgressBar = (): React.JSX.Element => {
    const { title, currentStep, totalSteps } = useRecoilValue(onsaProgressSelector);
    return (
        <>
            <span className="u-display-flex u-flex-justify-center u-color-supplement-grey-medium">
                {title}
            </span>
            <ProgressBar currentStep={currentStep} totalSteps={totalSteps} title={title} />
        </>
    );
};

export default OnsaProgressBar;
